import { render } from "./GalleryEdit.vue?vue&type=template&id=f34c2e72"
import script from "./GalleryEdit.vue?vue&type=script&lang=js"
export * from "./GalleryEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\devPrivate\\cmsDubaiMailing\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__